export function consoleError(message: string): void {
  console.error(message);
}



// WEBPACK FOOTER //
// ./src/uikit/utils/console.ts